export default __webpack_public_path__ + "static/1.1_DE-71493dc935557e82ff490d493821d22a.webp";